import { h } from 'vue'
import AtomButton from '~/components/atoms/button/button.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentWrapper, { class: 'our-enterprise-plan' }, () => [
    h(
      UiComponentContainer,
      {
        class: 'inner',
        onMouseenter: () => {
          if (
            props.isLottieAnimationLoaded
            && props.isDesktop
          ) {
            const player = document.querySelector('lottie-player')
            player.setDirection(1)
            player.play()
          }
        },
        onMouseleave: () => {
          if (
            props.isLottieAnimationLoaded
            && props.isDesktop
          ) {
            const player = document.querySelector('lottie-player')
            player.setDirection(-1)
            player.play()
          }
        },
      },
      () => [
        h('lottie-player', {
          class: 'background',
          src: '/lottie/enterprise/lottie.json',
        }),
        h(
          UiComponentHeading,
          { as: 'paragraph', level: 3 },
          () => props.record.title || props.componentEnterprise.title,
        ),
        h(
          UiComponentParagraph,
          {},
          () => props.record.text || props.componentEnterprise.text,
        ),
        h(UiComponentWrapper, { class: 'actions' }, () => [
          h(
            AtomButton,
            {
              action: 'Demo clicked',
              label: 'Enterprise section CTA',
              size: 'l',
              to: '#form-demo',
            },
            () => props.global.contactSales,
          ),
        ]),
      ],
    ),
  ])
}

Functional.props = {
  isDesktop: {
    required: true,
    type: Boolean,
  },
  isLottieAnimationLoaded: {
    required: true,
    type: Boolean,
  },
  componentEnterprise: {
    required: true,
    type: Object,
  },
  global: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
